// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import {
    createElement,
    classNames,
    Alert,
    Button,
    Fragment,
    Icon,
    List,
    Media,
    MediaSection,
    Panel,
    PropTypes,
    Status,
    Translate,
} from '@plesk/ui-library';
import Available from './Available';
import Bytes from './Bytes';

const Memory = ({ data, onCleanUp, isProcessing }) => (
    <Panel title={<Translate content="Memory.title" />}>
        <Media image={<Icon src="images/ram.png" size="lg" alt="RAM" />}>
            <MediaSection>
                <Translate content="Memory.description" />
            </MediaSection>
            {data.error ? (
                <MediaSection>
                    <Alert intent="danger">
                        <Status
                            intent="danger"
                            bottomAddon={data.error}
                        >
                            <Translate content="Memory.loadingError" />
                        </Status>
                    </Alert>
                </MediaSection>
            ) : (
                <Fragment>
                    <MediaSection>
                        <List
                            columns={[{
                                key: 'type',
                                title: '',
                            }, {
                                key: 'free',
                                title: <Translate content="Memory.free" />,
                                render: ({ free, total, requires }) => // eslint-disable-line react/display-name,react/prop-types
                                    (
                                        <Available free={free} total={total} min={requires} />
                                    ),
                            }]}
                            rowKey="type"
                            data={data}
                        />
                    </MediaSection>
                    <MediaSection>
                        <Translate content="Memory.recommend" />
                    </MediaSection>
                    <MediaSection>
                        <Button intent="primary" onClick={onCleanUp} state={isProcessing ? 'loading' : null} id="memory-cleanup">
                            <Translate content="Memory.cleanUp" />
                        </Button>
                    </MediaSection>
                </Fragment>
            )}
        </Media>
    </Panel>
);

Memory.propTypes = {
    data: PropTypes.array.isRequired,
    onCleanUp: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool.isRequired,
};

export default Memory;



// WEBPACK FOOTER //
// ./app/repair/Memory.js